/** @format */

/**
 * Reddit Pixel conversion tracking helpers.
 * conversionId must be a unique string per event to prevent duplicate counting.
 * See: https://www.reddit.com/advertising/conversion-tracking
 */

declare global {
    interface Window {
        rdt?: (...args: any[]) => void;
    }
}

const rdt = (...args: any[]) => {
    if (typeof window !== "undefined" && typeof window.rdt === "function") {
        window.rdt(...args);
    }
};

/** Fire when a user successfully creates an account. */
export const trackSignUp = (conversionId: string) => {
    rdt("track", "SignUp", { conversionId });
};

/** Fire when a contribution payment is successfully completed. */
export const trackPurchase = (conversionId: string) => {
    rdt("track", "Purchase", { conversionId });
};

/** Fire when a user submits a request to join a savings circle. */
export const trackJoinCircle = (conversionId: string) => {
    rdt("track", "Custom", { conversionId });
};

/** Fire when a user successfully creates a new savings circle. */
export const trackCreateCircle = (conversionId: string) => {
    rdt("track", "Custom", { conversionId });
};
